<form [formGroup]="form" [ngClass]="{'submitted': isSubmitted}">
  @if (consentsTranslations$ | async; as consentsTranslations) {
    <fieldset [disabled]="!memberConsents">
      @if (settings?.schema?.identifiers && settings?.schema?.consents) {
        <app-consents
            formControlName="consents"
            [allowedKeys]="consentKey ? [consentKey] : null"
            [consentsTranslations]="consentsTranslations">
          @if (member) {
            <div class="tw-mb-[25px]">
              @if (form.get('consents')?.value.email_marketing) {
                <div>
                  @if (!member?.properties?.email) {
                    <div
                        [ngClass]="{'is-focused': $any(email).isFocused}"
                        [class.has-error]="formErrors['email']"
                        class="form-group label-static is-empty email form-control-email">
                      <label class="control-label">
                        <span>{{ 'attributes.email' | translate }}</span>
                      </label>
                      <input class="form-control field-email"
                             type="email"
                             [formControl]="$any(form.get('email'))"
                             #email appFocusable (onFocusChange)="$any(email).isFocused = $event">
                      <app-input-errors [errorsForField]="formErrors['email']"
                                        [translationKey]="'errors.members'"/>
                    </div>
                  }
                </div>
              }
              @if (form.get('consents')?.value.sms_marketing) {
                <div>
                  @if (!member?.properties?.msisdn) {
                    <app-msisdn-input
                        [formErrors]="formErrors['msisdn']"
                        [showErrors]="isSubmitted"
                        [passedFormControl]="$any(form.get('msisdn'))"/>
                  }
                </div>
              }
            </div>
          }
        </app-consents>
      }
    </fieldset>
    <app-privacy-policy [editMode]="true"/>
  }
  <button (click)="onSave(form)" class="btn btn-raised btn-primary btn-block">{{ 'generic.save' | translate }}
  </button>
</form>
